import { TYPE_QUESTIONS, removeAccentsAndConvertLowercase } from "@educaplay/core";
import { GAME_MODES } from "./constants";

export function checkTypeAnswer({ sortedAnswered, questionType, isCaseSensitive, correctAnswersText, correctAnswersSelection }) {
    switch (questionType) {

        case GAME_MODES.EXPLORE: {
            return true;
        }

        case TYPE_QUESTIONS.Selection: {
            return checkSelectionAnswer(sortedAnswered, correctAnswersSelection);
        }

        case TYPE_QUESTIONS.Text: {

            return checkTextAnswer(sortedAnswered, correctAnswersText, isCaseSensitive);
        }


        default: {
            return false;
        }

    }

}

function checkTextAnswer(sortedAnswered, correctAnswersText, isCaseSensitive) {
    if (!sortedAnswered) return false;
    if (isCaseSensitive) {
        //Si es sensible a Mayusculas y Acentos
        return correctAnswersText.includes(sortedAnswered);
    }

    const formattedAnswer = removeAccentsAndConvertLowercase(sortedAnswered);
    for (let i = 0; i < correctAnswersText.length; i++) {
        if (formattedAnswer === removeAccentsAndConvertLowercase(correctAnswersText[i])) {
            return true;
        }
    }
    return false;
}

function checkSelectionAnswer(sortedAnswered, correctAnswersSelection) {
    return sortedAnswered === correctAnswersSelection[0];
}

async function preloadImage(url) {
    return new Promise((resolve) => {
        const image = new Image();
        image.src = url;
        image.onload = () => {
            resolve(true);
        }
    })
}

export async function preloadImages(images) {
    const promises = images.map((image) => preloadImage(image));
    return Promise.all(promises);
} 